import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Agent } from "@/types/agent";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import ContractReviewDashboard from "../../pages/dashboard/contract-review";
import DocumentDraftingDashboard from "../../pages/dashboard/document-generator";
import CasePredictionDashboard from "../../pages/dashboard/case-prediction";
import LegalResearchDashboard from "../../pages/dashboard/legal-research";
import ChatDashboard from "../../pages/dashboard/legal-chatbot";
import { useAuth } from "@/contexts/AuthContext";

// Import other dashboards...

const AgentDashboard: React.FC = () => {
  const { agentSlug } = useParams<{ agentSlug: string }>();
  const { user } = useAuth();
  const [agent, setAgent] = useState<Agent | null>(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (user && agentSlug) {
      fetchAgent();
    }
  }, [user, agentSlug]);

  const fetchAgent = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("ai_agents")
        .select("*")
        .eq("slug", agentSlug)
        .eq("user_id", user?.id)
        .single();

      if (error) throw error;
      setAgent(data);
    } catch (error) {
      console.error("Error fetching agent:", error);
      toast({
        title: "Error",
        description: "No se pudo cargar la información del agente.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!agent) {
    return <div>Agente no encontrado</div>;
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>{agent.name}</CardTitle>
        </CardHeader>
        <CardContent>
          <p>{agent.description}</p>
          <div className="mt-4">
            <Button>Iniciar conversación</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AgentDashboard;
